/**
 * useCountUp — a number that walks up to its value on mount, once.
 *
 * 🔴 EXTRACTED FROM CorpusMeter, NOT REIMPLEMENTED BESIDE IT. The meter's
 * percentile has counted up since the meter shipped; the team report's headline
 * points now do the same. Two rAF loops with the same easing and different
 * off-by-ones is exactly the kind of pair that drifts, so there is one loop and
 * both call it.
 *
 * 🔴 THE EASING IS A MIRROR OF THE CSS CURVE, NOT A READ OF IT. A rAF loop
 * cannot consume a CSS timing function, so this applies a cubic ease-out, which
 * is the same shape as the bezier in METER_LOOK.easing and RATE_MOTION.easing.
 * When a count-up runs beside a CSS transition — which is the whole point in the
 * meter, where the marker slides while the number climbs — they agree the whole
 * way rather than only at the two ends. Change one curve and change the other.
 *
 * 🔴 ONCE PER MOUNT. The effect keys on the target and the stillness flag and
 * nothing else, so a re-render never restarts the climb; a genuinely new target
 * (a new roster) does, which is the point.
 *
 * Under prefers-reduced-motion the caller passes `still` and the hook returns
 * the finished value on the very first render — there is no frame at zero for a
 * reader who asked not to be moved.
 *
 * @param target  the value to arrive at
 * @param ms      how long to take
 * @param still   true to skip the animation and return `target` immediately
 * @returns the current value
 */
import { useEffect, useRef, useState } from "react";

export default function useCountUp(target, ms, still) {
  const [shown, setShown] = useState(still ? target : 0);
  const raf = useRef(0);

  useEffect(() => {
    if (still) {
      setShown(target);
      return undefined;
    }
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min(1, (now - t0) / ms);
      setShown(target * (1 - (1 - p) ** 3));
      if (p < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [target, ms, still]);

  return shown;
}
